import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import { FC, useEffect, useRef, useState } from 'react';

export interface IProps {
  rows?: number;
  titleClassName?: string;
}

export const TooltipEllipsis: FC<IProps & TooltipProps> = (props) => {
  const { rows = 1, titleClassName = '', title, children, ...rest } = props;
  if (rows < 1) {
    console.error('rows must be greater than 0');
  }

  const divRef = useRef<HTMLDivElement>(null);
  const spanRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (divRef.current && spanRef.current) {
      if (rows > 1) {
        if (divRef.current.offsetHeight < spanRef.current.offsetHeight) {
          setShowTooltip(true);
        }
      } else {
        if (divRef.current.offsetWidth < spanRef.current.offsetWidth) {
          setShowTooltip(true);
        }
      }
    }
  }, [title]);

  return (
    <Tooltip {...rest} title={showTooltip ? title : ''}>
      <div ref={divRef} className={`${titleClassName} truncate`}>
        <span ref={spanRef}> {children}</span>
      </div>
    </Tooltip>
  );
};
